export namespace Paths {
  export const oldVinesInfo = "/old-vines-info";
  export const about = "/about";
  export const advancedSearch = "/advanced-search";
  export const contest = "/contest";
  export const submit = "/submit";
  export const feedback = "/feedback";
  export const privacy = "/privacy";
  export const faq = "/faq";
  export const thankYou = "/thank-you";
  export const vineyards = "/vineyards";
  export const vineyard = "/vineyard/:id";
  export const login = "/login";
  export const admin = "/admin";
  export const errors = "/admin/errors";
  export const submissions = "/admin/submissions";
  export const searchHistory = "/admin/search-history";
  export const synonym = "/synonym";
  export const seal = "/seal";
  export const sealFaq = "/seal/faq";
  export const sealGuidelines = "/seal/guidelines";
  export const sealRegister = "/seal/register";
  export const sealPayment = "/seal/payment";
  export const sealConfirmation = "/seal/confirmation";
}